import { render, staticRenderFns } from "./ReportingPagev2.vue?vue&type=template&id=b739ff80&scoped=true&"
import script from "./ReportingPagev2.vue?vue&type=script&lang=js&"
export * from "./ReportingPagev2.vue?vue&type=script&lang=js&"
import style0 from "./ReportingPagev2.vue?vue&type=style&index=0&id=b739ff80&scoped=true&lang=css&"
import style1 from "./ReportingPagev2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b739ff80",
  null
  
)

export default component.exports